import { apiRequest } from '@/services/api/apiClient.js'
import internalApi from '@/services/api/internalApi.js'

const mockActions = {
    edit: 'edit',
    view: 'view',
    delete: 'delete',
    create: 'create',
    list: 'list',
}

export function getRHDigitalMockActions() {
    return mockActions
}

export function getRHDigitalDepartments({ page = 1, limit = 10, ...filters }) {
    return apiRequest({
        client: internalApi,
        method: 'get',
        url: '/api/mock/rhdigital/departments',
        params: { page, limit, ...filters },
    })
}

export function getRHDigitalSectors({ page = 1, limit = 10, ...filters }) {
    return apiRequest({
        client: internalApi,
        method: 'get',
        url: '/api/mock/rhdigital/sectors',
        params: { page, limit, ...filters },
    })
}

export function getRHDigitalTeams({ page = 1, limit = 10, ...filters }) {
    return apiRequest({
        client: internalApi,
        method: 'get',
        url: '/api/mock/rhdigital/teams',
        params: { page, limit, ...filters },
    })
}
